<div class="overlay database-selector ">

    <div class="overlay-header">
        <h2>Database Selector</h2>
    </div>
    <div class="section-divider"></div>
    <section>
        <f-alert variant="error" [ngClass]="{'error-wrapper hide': !this.isDatabaseSelectorApiFailure}">
            {{this.errorMessage}}<button class="btn-alert"> Try again</button>
        </f-alert>
    </section>
    <form [formGroup]="databaseSelectorForm" autocomplete="off">
        <div class="overlay-body">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <!-- added input field to avoid focus from dropdown -->
                        <h3>Select a client <input type="text" value="test" class="opacity-none" /></h3>
                    </div>

                </div>

                <div class="row row-bottom-space">
                    <!-- <div class="col-md-6" *ngIf="false">
                        <app-alight-drop-down [group]="customerSearchForm" [controlName]="'clientId'" [required]="false"
                            description="clientName" label="Client" [value]="'clientId'" [list]="
                                rootService.liveChatCTS.length < 2
                                  ? customerService.clients
                                  : rootService.liveChatCTS
                              " (change)="onClientDropDownChange($event)">
                        </app-alight-drop-down>

                    </div> -->

                    <div class="col-md-6">
                        <app-alight-smart-search-drop-down [group]="databaseSelectorForm" [controlName]="'clientName'"
                            [required]="true" description="clientName" [disable]="false" label="Client"
                            [value]="'clientName'" [list]="                         
                               customerService.clients                             
                          " (change)="onClientDropDownChange($event)">
                        </app-alight-smart-search-drop-down>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <h4>Default Configurations</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 disabled-item">
                        <div class="data-label" [ngClass]="{'disabledLink': !this.isClientSelected}">UDP Database</div>
                        <div class="data-value" [ngClass]="{'disabledLink': !this.isClientSelected}">
                            {{this.udpDataBaseName}}</div>
                    </div>
                    <div class="col-md-4">
                        <div class="data-label"
                            [ngClass]="{'disabledLink': !this.isTBAClient || !this.isClientSelected}">TBA Lifecycle
                        </div>
                        <div class="data-value"
                            [ngClass]="{'disabledLink': !this.isTBAClient || !this.isClientSelected}">
                            {{getTBALifecycleName(tbaLifeCycle)}}</div>
                    </div>
                    <div class="col-md-4">
                        <div class="data-label"
                            [ngClass]="{'disabledLink': !this.isTBAClient || !this.isClientSelected}">Trans ID</div>
                        <div class="data-value"
                            [ngClass]="{'disabledLink': !this.isTBAClient || !this.isClientSelected}">{{this.transId}}
                        </div>
                    </div>
                </div>
                <div class="section-divider"></div>
                <div class="row">

                    <div class="col-md-12">
                        <h3>Change Configurations</h3>
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-12">
                        <h4>Current Configurations</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="data-label" [ngClass]="{'disabledLink': !this.isClientSelected}">UDP Database</div>
                        <div class="data-value" [ngClass]="{'disabledLink': !this.isClientSelected}">
                            {{crrUdpDataBaseName}}</div>
                    </div>
                    <div class="col-md-4">
                        <div class="data-label"
                            [ngClass]="{'disabledLink': !this.isTBAClient || !this.isClientSelected}">TBA Lifecycle
                        </div>
                        <div class="data-value"
                            [ngClass]="{'disabledLink': !this.isTBAClient || !this.isClientSelected}">
                            {{getTBALifecycleName(crrTbaLifeCycle)}}</div>
                    </div>
                    <div class="col-md-4 disabledItem">
                        <div class="data-label"
                            [ngClass]="{'disabledLink': !this.isTBAClient || !this.isClientSelected}">Trans ID</div>
                        <div class="data-value"
                            [ngClass]="{'disabledLink': !this.isTBAClient || !this.isClientSelected}">
                            {{crrTransId}}</div>
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-12 new-config">
                        <p><strong>New Configurations </strong></p><button title="Reset to default"
                            (click)="resetToDefault()" [ngClass]="{'disabledLink': !this.enableResetToDefault}">(Reset
                            to default)</button>
                    </div>
                </div>
                <div class="row  new-config-fields" [ngClass]="{'disabledLink': !this.isClientSelected}">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill" class="component-box">
                            <mat-label [ngClass]="{'disabledLink': !this.isClientSelected}">UDP Database</mat-label>
                            <input [disabled]='!disable' matInput formControlName="udpDatabaseName" id="UDP Database"
                                class="pointer-events: none;" (focus)="onFocus($event)" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-4" [ngClass]="{'disabledLink': !this.isTBAClient || !this.isClientSelected}">
                        <mat-form-field appearance="fill" class="component-box">
                            <mat-label [ngClass]="{'disabledLink': !this.isTBAClient || !this.isClientSelected}">TBA
                                Lifecycle</mat-label>
                            <mat-select formControlName="tbaLifeCycle">
                                <mat-option *ngFor="let vaidValues of validValuesList" [value]="vaidValues.fieldValue">
                                    {{ vaidValues.fieldValueDescription }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4" [ngClass]="{'disabledLink': !this.isTBAClient ||  !this.isClientSelected}">
                        <mat-form-field appearance="fill" class="component-box">
                            <mat-label [ngClass]="{'disabledLink': !this.isTBAClient ||  !this.isClientSelected}">Trans
                                ID</mat-label>
                            <input [disabled]='!disable' matInput formControlName="transId" id="Trans ID"
                                (focus)="onFocus($event)" />
                        </mat-form-field>
                    </div>


                </div>
            </div>
        </div>
    </form>

    <div class="button-controls">
        <f-button text="Close" type="button" variant="action" (click)="closeDatabaseSelector()">
        </f-button>
        <f-button text="Submit" [disabled]="!this.isClientSelected || databaseSelectorForm?.invalid" type="button"
            variant="progressive" (click)="submitDbChange()"></f-button>
    </div>



</div>